// Utilitaire GTM dataLayer — tracking GAEvent + pageview SPA

/** Normalise une valeur GA : minuscules, sans accents, espaces → underscores, sans caracteres speciaux */
export function normalizeGAValue(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
}

/** Push un evenement GAEvent (clic bouton vert) */
export function trackEvent(buttonName: string) {
  window.dataLayer?.push({
    event: 'GAEvent',
    eventCategory: 'clickbutton',
    eventAction: normalizeGAValue(buttonName),
    eventLabel: 'poc_scop',
  })
}

/** Push un evenement pageview SPA */
export function trackPageView(params: {
  loginStatus: 'oui' | 'non'
  userId: string
  contactId: string
  previousUrl: string
  pageUrl: string
  pageTitle: string
}) {
  window.dataLayer?.push({
    event: 'pageview',
    ...params,
    pageTitle: normalizeGAValue(params.pageTitle),
  })
}

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}
